import React, { useEffect, useState } from "react";
import "./Contact.css";
import { FaAddressCard } from "react-icons/fa";
import { MdPermContactCalendar } from "react-icons/md";
import { TbClockHour3Filled } from "react-icons/tb";
import { MdArrowForwardIos } from "react-icons/md";
import contact from "../assets/contact.jpg";
import Navigation from "./Navigation";
import Footer from "./Footer";
import Map from "./Map";
import { Link } from "react-router-dom";

const Contact = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default page reload
    setIsSubmitting(true);

    // Make sure all fields are filled
    const { name, email, phone, message } = formData;
    if (!name || !email || !phone || !message || !isChecked) {
      alert("Please fill all fields!");
      setIsSubmitting(false);
      return;
    }

    try {
      const params = new URLSearchParams(formData).toString();

      const response = await fetch(
        `https://script.google.com/macros/s/AKfycby4X_5cqTCm34BfyaMwREJ_PuOMsBzzc3L0eXHU0-FAL6zDBP9J3Xf865XBhrbsTGp0/exec?${params}`,
        { method: "GET" } // Use GET to avoid CORS issues
      );

      const result = await response.json();

      if (result.status === "success") {
        alert("Message sent successfully!");
        setFormData({ name: "", email: "", phone: "", message: "" }); // Clear form
        setIsChecked(false);
      } else {
        alert("Something went wrong: " + result.message);
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred while sending the message.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="sticky top-0 z-50 bg-white shadow-md w-full">
        <Navigation />
      </div>
      <div className="relative h-[210px] overflow-hidden">
        <img
          src={contact}
          alt="Contact Us"
          className="w-full h-full object-cover transition-transform duration-1000 hover:scale-105"
        />

        <div className="absolute inset-0 bg-black/50"></div>

        <div className="absolute inset-0 flex items-center px-4 xl:px-20">
          <h1
            className={`uppercase text-xl md:text-2xl lg:text-5xl text-white transition-all duration-700 ${
              isVisible
                ? "translate-x-0 opacity-100"
                : "-translate-x-10 opacity-0"
            }`}
          >
            Contact Us
          </h1>
        </div>
      </div>

      <div className="w-full px-4 xl:px-20 py-4 xl:py-6">
        <div
          className={`flex flex-wrap items-center gap-2 text-md md:text-lg transform transition-all duration-700 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"
          }`}
        >
          <Link
            to="/"
            className="uppercase text-green-700 hover:underline transition-colors duration-300 text-md md:text-lg"
          >
            Home
          </Link>
          <MdArrowForwardIos className="text-gray-500 text-sm sm:text-base mt-0.5" />
          <p className="uppercase text-md md:text-lg text-gray-800">
            Contact Us
          </p>
        </div>
      </div>

      <div className="w-full px-4 lg:px-8 mx-auto text-center space-y-3 md:space-y-4 flex-shrink-0">
        <h1 className="text-2xl md:text-4xl font-semibold text-gray-900 leading-tight">
          Get in Touch
        </h1>
        <p className="text-md md:text-2xl text-gray-700 leading-relaxed">
          Welcome to Nohmi Bosai (India) Pvt. Ltd, contact us today
        </p>
      </div>

      <div className="px-4 lg:px-20 py-4 lg:py-10">
        <div className="flex flex-col lg:flex-row justify-between gap-10">
          <div className="flex-1">
            <p className="text-base md:text-xl text-justify text-gray-700 max-w-xl">
              Connect with us today for expert solutions tailored to your needs.
              Our team is ready to assist you. Contact us now!
            </p>

            <div className="mt-8 space-y-5">
              <div className="flex items-start space-x-4">
                <FaAddressCard className="w-10 h-10 text-green-700 mt-1 flex-shrink-0" />
                <div className="max-w-sm">
                  <h1 className="text-xl md:text-2xl font-semibold text-gray-800">
                    Our Address
                  </h1>
                  <p className="text-md md:text-base text-gray-900 text-justify mt-1">
                    Unit 303-306, 3rd Floor, CENTRUM PLAZA, DLF Golf Course Rd,
                    Sector 53, Gurugram, Haryana 122002
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <MdPermContactCalendar className="w-10 h-10 text-green-700 mt-1 flex-shrink-0" />
                <div>
                  <h1 className="text-xl md:text-2xl font-semibold text-gray-800">
                    Contact
                  </h1>
                  <p className="text-md text-base mt-1">
                    Mobile : 0124-6572250
                  </p>
                  <p className="text-md text-base mt-1">
                    Mail : info@nohmi-india.com
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <TbClockHour3Filled className="w-10 h-10 text-green-700 mt-1 flex-shrink-0" />
                <div>
                  <h1 className="text-xl md:text-2xl font-semibold text-gray-800">
                    Working Hours
                  </h1>
                  <p className="text-md text-base mt-1">
                    Monday - Friday : Standard Business Hours
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0 text-right lg:text-left w-full lg:max-w-lg mx-auto mt-2 md:mt-4 lg:mt-10 ">
            {/* Heading */}
            <h1 className="text-left text-2xl md:text-3xl font-semibold text-green-800 mb-6">
              Ready to Get Started?
            </h1>

            {/* Contact Form */}
            <form
              className="w-full grid grid-cols-1 gap-3"
              onSubmit={handleSubmit}
            >
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your name"
                className="p-2 border border-gray-400 rounded-md w-full shadow-md"
                required
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your email address"
                className="p-2 border border-gray-400 rounded-md w-full shadow-md"
                required
              />
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Your contact number"
                className="p-2 border border-gray-400 rounded-md w-full shadow-md"
                required
              />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Write your message..."
                className="p-3 border border-gray-400 rounded-md w-full h-40 resize-none shadow-md"
                required
              ></textarea>

              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  id="not-robot"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  className="w-4 h-4 accent-green-800"
                  required
                />
                <label
                  htmlFor="not-robot"
                  className="text-base md:text-lg text-gray-800"
                >
                  I am not a robot
                </label>
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="mt-2 bg-green-700 hover:bg-green-800 text-white w-full text-lg px-6 py-2 rounded-md transition duration-300"
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      </div>

      <div>
        <Map />
      </div>
      <div>
        <Footer />
      </div>
    </>
  );
};

export default Contact;
